/*@ngInject*/
const LabelButtonController = function ($scope, $element, $timeout, coreConstant) {

    const timeoutList = [];

    this.$onInit = function () {
        $element.addClass('umDropdownLabelButton');
        this.enabled = this.enabled === undefined ? true : this.enabled;
    };

    this.$onChanges = function (changes) {};

    $scope.$on(coreConstant.event.dropdown.searchInterface.FOCUS_CLEAR_SELECTED_BUTTON, () => {
        this.searchInterfaceFocus = true;
        timeoutList.push($timeout(function () {}, 0));
    });

    $scope.$on(coreConstant.event.dropdown.searchInterface.BLUR_CLEAR_SELECTED_BUTTON, () => {
        this.searchInterfaceFocus = false;
        timeoutList.push($timeout(function () {}, 0));
    });

    $scope.$on('$destroy', function () {
        _.each(timeoutList, function (item) {
            $timeout.cancel(item);
        });
    });
};

angular.module('umCore')
    .controller('umLabelButtonController', LabelButtonController);
